import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { ListComponent } from '@app/common/templates/list/list.component';
import { Module } from '@app/models/permission';
import { Policy } from '@app/models/policy';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import { ExportService } from '@app/services/export.service';
import { SettingsService } from '@app/services/settings.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { MaintenanceDialog } from './maintenanceDialog/maintenanceDialog.component';
import { environment } from '@environments/environment';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { WeekDay } from '@angular/common';
import { EventColor } from 'calendar-utils';
import { addDays, addHours, endOfMonth, getDay, parseISO, previousMonday, setHours, setMilliseconds, setMinutes, setSeconds, startOfDay, startOfWeek, subDays } from 'date-fns';
import { VehicleReplaceComponentDialogComponent } from '../detail/vehicle_replace_component_dialog/vehicle_replace_component_dialog.component';
import { Subject } from 'rxjs';

@Component({
	templateUrl: './list.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/list/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblFahrzeugListComponent extends ListComponent {
	//env_supportmail: string = '';
	isVisy: boolean = false;
	isVisyMasterDB: boolean = false;
	url_detail = PATH.DETAIL;
	url_edit = PATH.EDIT;

	private allIncludingInactive: boolean = false;
	showModal: boolean = false;
	view: CalendarView = CalendarView.Month;
	CalendarView = CalendarView;
	viewDate: Date = new Date();
	weekStartDay: WeekDay = WeekDay.Monday;
	locale: string = 'en';
	calendarRefresh = new Subject<void>();
	events: CalendarEvent[] = [];
	date: Date;
	activeDayIsOpen: boolean = true;

	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public changeDetectorRef: ChangeDetectorRef,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public elRef: ElementRef,
		public exportService: ExportService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public settingsService: SettingsService,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, changeDetectorRef, confirmationService, crudService, elRef, exportService, globals, messageService, router, settingsService, translate, dialogService);

		this.env_supportmail = environment.supportEmail;
		if(!this.env_supportmail || this.env_supportmail.trim().length < 1) {
			this.env_supportmail = 'support@visy-gmbh.com';
		}
		this.apiUrl = 'TblFahrzeug';
		this.name = 'MENU.FAHRZEUGE';
		this.url = '/' + PATH.FAHRZEUG;
		this.module = Module.Masterdata;

		this.possibleCols = [
			{ type: 'numeric', key: 'lfd_nummer', required: true, width: 100 },
			{ type: 'text', key: 'ankey', required: true, width: 400 },
			{ type: 'text', key: 'bezeichnung', required: false, width: 400 },
			{ type: 'text', key: 'kennzeichen', required: true, width: 400 },
			{ type: 'text', key: 'normalized_kennzeichen', required: true, width: 400 },
			{ type: 'text', key: 'logbox_serial', required: false, width: 400 },
			{ type: 'text', key: 'fahrgestellnummer', required: true, width: 400 },
		];
		this.cols = [
			{ type: 'numeric', key: 'lfd_nummer', required: true, width: 100 },
			{ type: 'text', key: 'ankey', required: true, width: 400 },
			{ type: 'text', key: 'bezeichnung', required: true, width: 400 },
			{ type: 'text', key: 'kennzeichen', required: true, width: 400 },
			{ type: 'text', key: 'logbox_serial', required: false, width: 400 },
			{ type: 'text', key: 'fahrgestellnummer', required: true, width: 400 },
		];
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.LIST', routerLink: [this.url + '/' + PATH.LIST] }
		]);

		this.isVisy = this.accountService.isAuthorized(Policy.ViSyUser);

		this.accountService.getUserConnectionIsViSyMasterDB().then(resultVisyMasterDB => {
			if(resultVisyMasterDB != null && resultVisyMasterDB != undefined) {
				if(resultVisyMasterDB['value'] != null && resultVisyMasterDB['value'] != undefined) {
					if(resultVisyMasterDB['value'] === true) {
						this.isVisyMasterDB = true;
					}
				}
			}
		}).catch(() => {
			this.isVisyMasterDB = false;
		});

		if (this.isVisy) {
			this.possibleCols.push(
				{ type: 'text', key: 'FREMD_firma_bezeichnung', required: false, width: 400 },
				{ type: 'text', key: 'lexware_projekt_nummer', required: false, width: 400 },
				{ type: 'text', key: 'fremd_auftragsnummer', required: false, width: 400 },
				{ type: 'text', key: 'fremd_bestellnummer', required: false, width: 400 },
				{ type: 'text', key: 'jira_url', required: false, width: 400 },
				{ type: 'text', key: 'geplanter_aufbau_kw_jjjj', required: false, width: 400 },
				{ type: 'text', key: 'bemerkung', required: false, width: 400 },
				{ type: 'date', key: 'abholung', required: false, width: 400 },
				{ type: 'date', key: 'anlieferung', required: false, width: 400 },
				{ type: 'date', key: 'aufbau_start', required: false, width: 400 },
				{ type: 'date', key: 'aufbau_ende', required: false, width: 400 },
				{ type: 'text', key: 'aufbau_ort', required: false, width: 400 },
				{ type: 'boolean', key: 'vorbereitung_set_1', required: false, width: 400 },
				{ type: 'boolean', key: 'vorbereitung_set_2', required: false, width: 400 },
				{ type: 'boolean', key: 'vorbereitung_set_3', required: false, width: 400 },
				{ type: 'boolean', key: 'datenaufzeichnung', required: false, width: 400 },
				{ type: 'boolean', key: 'rueckfahrkataster', required: false, width: 400 },
				{ type: 'date', key: 'rueckfahrkataster_bis', required: false, width: 400 },
				{ type: 'string', key: 'simkartennummer', required: false, width: 400 },
				{ type: 'date', key: 'simkarte_bis', required: false, width: 400 },
				{ type: 'boolean', key: 'rueckfahrassistent', required: false, width: 400 },
				{ type: 'boolean', key: 'unterlaufschutz_seitenlader', required: false, width: 400 },
				{ type: 'boolean', key: 'abbiege_rechts_180_grad', required: false, width: 400 },
				{ type: 'boolean', key: 'abbiege_rechts_3d', required: false, width: 400 },
				{ type: 'boolean', key: 'abbiege_rechts_kamera', required: false, width: 400 },
				{ type: 'boolean', key: 'abbiege_rechts_radar', required: false, width: 400 },
				{ type: 'boolean', key: 'abbiege_links_3d', required: false, width: 400 },
				{ type: 'boolean', key: 'abbiege_links_kamera', required: false, width: 400 },
				{ type: 'boolean', key: 'abbiege_links_radar', required: false, width: 400 },
				{ type: 'boolean', key: 'canbus_fms', required: false, width: 400 },
				{ type: 'boolean', key: 'canbus_tail', required: false, width: 400 },
				{ type: 'boolean', key: 'canbus_faun', required: false, width: 400 },
				{ type: 'boolean', key: 'canbus_hs', required: false, width: 400 },
				{ type: 'boolean', key: 'canbus_radar', required: false, width: 400 },
				{ type: 'numeric', key: 'info_sets', required: false, width: 400 },
				{ type: 'numeric', key: 'info_io', required: false, width: 400 },
				{ type: 'numeric', key: 'info_canbus', required: false, width: 400 },
				{ type: 'numeric', key: 'info_features', required: false, width: 400 },
			);

			this.cols.push(
				{ type: 'text', key: 'FREMD_firma_bezeichnung', required: false, width: 400 },
				{ type: 'text', key: 'lexware_projekt_nummer', required: false, width: 400 },
				{ type: 'text', key: 'aufbau_ort', required: false, width: 400 },
				{ type: 'date', key: 'anlieferung', required: false, width: 400 },
				{ type: 'boolean', key: 'vorbereitung_set_1', required: false, width: 400 },
				{ type: 'boolean', key: 'vorbereitung_set_2', required: false, width: 400 },
				{ type: 'boolean', key: 'vorbereitung_set_3', required: false, width: 400 },
				{ type: 'boolean', key: 'datenaufzeichnung', required: false, width: 400 },
				{ type: 'boolean', key: 'rueckfahrkataster', required: false, width: 400 },
				{ type: 'text', key: 'bemerkung', required: false, width: 400 },
			);
		}
	}

	maintenance() {
		const ref = this.dialogService.open(MaintenanceDialog, {
			header: this.translate.instant('VEHICLES.MAINTENANCE'),
			width: '70%',
			data: this.entries
		});
	}

	switchArchivierte() {
		this.allIncludingInactive = !this.allIncludingInactive;
		this.getAllEntries();
	}

	// override
	getAllEntries() {
		this.loading += 1;
		this.messageService.clear('refresh');
		if (this.allIncludingInactive) {
			this.crudService.getAllVehiclesIncludingInactive().then(res => {
				this.processEntries(res);
				this.resizeTableWidthFromContent(false);
			}).catch(err => {
				err.error.forEach(e => {
					this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
				})
			}).finally(() => {
				this.loading -= 1;
			});
		} else {
			this.crudService.getAllVehicles().then(res => {
				this.processEntries(res);
				this.resizeTableWidthFromContent(false);
			}).catch(err => {
				err.error.forEach(e => {
					this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
				})
			}).finally(() => {
				this.loading -= 1;
			});
		}
	}

	getWeekStart(d) {
		var day = d.getDay()
		// This makes it so even if the week starts on something else,
		// it'll still work
		var diff = addDays(subDays(d,day),this.weekStartDay);
		console.log(day,diff);
		return setMilliseconds(setSeconds(setMinutes(setHours(diff,0),0),0),0);
	}

	getWeekEnd(d) {
		return addDays(this.getWeekStart(d),6);
	}

	getColorHash(input: string) {
		const hash = Array.from(input).reduce((acc, char) => {
			acc = ((acc << 5) - acc) + char.charCodeAt(0);
			return acc & acc; // Convert to 32-bit integer
		}, 0);

		// Make sure hash is positive and convert to hex
		const hex = ((hash >>> 0).toString(16)).padStart(6, "0").slice(0, 6);

		const color = {
			primary: `#${hex}`,
			secondary: `#${hex}`,
		};
		return color;
	}

	updateCalendar() {
		this.loading += 1;
		this.events = [];
		this.crudService.getVehiclesForTheWeek(this.viewDate).then(res => {
			//console.log(res);
			for (const entry of res) {
				this.loading += 1;
				this.crudService.getVehicleByAkteId(Number(entry["ds_this_id"])).then(vehicleResult => {
					var eventTitle = "---"
					var vehicleId = 0;
					if(vehicleResult && vehicleResult.ds_this_id) {
						vehicleId = vehicleResult.ds_this_id;
						// vehicle ankey als fallback
						eventTitle = "(" + vehicleResult.ankey.toString() + ")";
					}
					// lexware_projekt_nummer hat höhere priorität
					if (entry["lexware_projekt_nummer"] && entry["lexware_projekt_nummer"] != "") {
						eventTitle = entry["lexware_projekt_nummer"]
					}
					if (eventTitle.length > 8) {
						eventTitle = eventTitle.slice(0, 8) + "...)" 
					}

					var originDate = new Date(parseISO((entry["VIRTUAL_geplanter_aufbau_kw_asDateTime"])));
					var event: CalendarEvent = {
						meta: {
							id: vehicleId
						},
						start: this.getWeekStart(originDate),
						end: this.getWeekEnd(originDate),
						title: eventTitle,
						color: this.getColorHash(entry["geplanter_aufbau_kw_jjjj"]+entry["ds_this_id"]),
						allDay: false,
						resizable: {
							beforeStart: false,
							afterEnd: false,
						},
						draggable: false,
					}
					this.events.push(event);
				}).catch(err => {
					err.error.forEach(e => {
						this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
					})
				}).finally(() => {
					this.loading -= 1;
					this.calendarRefresh.next();
				});
			}
		}).catch(err => {
			err.error.forEach(e => {
				this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
			})
		}).finally(() => {
			this.loading -= 1;
					this.calendarRefresh.next();
		});
	}

	closeOpenMonthViewDay() {
		this.activeDayIsOpen = false;
	}


	openCalendar() {
		if (this.isVisy && this.isVisyMasterDB) {
			this.showModal = true;
			this.updateCalendar();
		}
	}
		
	isSameDay(d1: any, d2: any): boolean {
		const date1 = new Date(d1);
		const date2 = new Date(d2);
		return date1.getFullYear() === date2.getFullYear() &&
				date1.getMonth() === date2.getMonth() &&
				date1.getDate() === date2.getDate();
	}

	clickEvent(event: CalendarEvent) {
		if(event && event.meta && event.meta.id) {
			this.router.navigate([this.url + '/' + this.url_detail + '/' + event.meta.id]);
		}
	}
}
